import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

let Bar

function ProductAnalyticsPricingChart({ avgProductPriceData, avgTransactionPriceData, labels }) {
  const [isLoaded, setIsLoaded] = useState()

  useEffect(() => {
    import('react-chartjs-2').then(module => {
      Bar = module.Bar
      setIsLoaded(true)
    })
  }, [])

  if (!isLoaded) return null

  const chartConfiguration = {
    data: {
      labels,
      datasets: [
        {
          label: 'Avg. model price ($)',
          data: avgProductPriceData,
          backgroundColor: 'rgba(103, 196, 176, 0.8)',
        },
        {
          label: 'Avg. transaction price ($)',
          data: avgTransactionPriceData,
          backgroundColor: 'rgba(166, 82, 100, 0.7)',
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{ display: false }],
      },
      legend: {
        onClick: (e) => e.stopPropagation(),
      },
      tooltips: {
        enabled: false,
      },
    },
  }

  return (
    <div className="chart-container">
      <div className="chart-container__description">
        <h3>Pricing</h3>
        <p>
          Model price vs Transaction price. Compare the average price of models in a category with the average
          price of models that were purchased. Depending on the quality of your model you can adjust the
          prices to get more sales.
        </p>
      </div>

      <div className="chart-container__chart">
        <Bar redraw data={chartConfiguration.data} options={chartConfiguration.options} />
      </div>
    </div>
  )
}

ProductAnalyticsPricingChart.propTypes = {
  avgProductPriceData: PropTypes.array,
  avgTransactionPriceData: PropTypes.array,
  labels: PropTypes.array,
}

ProductAnalyticsPricingChart.defaultPropTypes = {
  avgProductPriceData: [],
  avgTransactionPriceData: [],
  labels: [],
}

export default ProductAnalyticsPricingChart
